import { pathOr } from 'ramda';

import { PAGE_REQUEST } from 'store/app/types';

import { getErrorMessage } from 'utils/stringUtils';

import { types } from './actions';

const initialState = {
  isFetching: false,
  error: null,
  showTermsAcceptanceModal: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PAGE_REQUEST:
      return {
        ...initialState,
        showTermsAcceptanceModal: state.showTermsAcceptanceModal,
      };
    case types.LOGIN:
      return { ...state, isFetching: true };
    case types.LOGIN_SUCCESS: {
      const showTermsAcceptanceModal = pathOr(
        false,
        ['user', 'termsAcceptanceRequired'],
        action.payload,
      );
      return {
        ...state,
        showTermsAcceptanceModal,
        isFetching: false,
      };
    }
    case types.LOGIN_ERROR:
      return {
        ...state,
        error: getErrorMessage(action.payload),
        isFetching: false,
      };
    case types.LOGOUT_SUCCESS:
      return initialState;
    case types.ACCEPT_TERMS_SUCCESS:
      return { ...state, showTermsAcceptanceModal: false };
    default:
      return state;
  }
};

export default reducer;
